import React, { useEffect, useState } from 'react'
import { styled } from 'linaria/react'
import ProductWishListCard from '../../Core/Cards/ProductWishListCard'
import { useDigifiSearchCore } from '../../DigifiSearch/Hooks/Core/useDigifiSearchCore'

const ProductsContainer = styled.div`
   // X-padding prevent cutting off shadow on productcards
   padding: 0 0.5rem;
`

const ProductSpareParts = ({ spareParts }) => {
   const { getProductsByItemNos } = useDigifiSearchCore()
   const [sparePartsProducts, setSparePartsProducts] = useState([]);

   useEffect(() => {
      if (!spareParts?.length) {
         return
      }
      (async () => {
         const productData = await getProductsByItemNos({ itemNos: spareParts, pageSize: 48 })
         setSparePartsProducts(productData)
      })()
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [spareParts])

   if (!sparePartsProducts?.length) {
      return <></>
   }

   return (
      <ProductsContainer>
         <div className="row">
            {sparePartsProducts?.map((product, i) => {
               return (
                  <div key={i} className="col-12 col-md-6 col-lg-12 col-xxl-6">
                     <ProductWishListCard
                        product={product}
                        hideCancelIcon={true}
                     />
                  </div>
               )
            })}
         </div>
      </ProductsContainer>
   )
}

export default ProductSpareParts
